import React, { Component } from 'react';
import { omit } from 'lodash';
import ensureAuth from '../../hoc/ensure-auth';

type Props = {
  tagName?: React.ElementType;
  children?: React.ReactNode;
  /** Forwarded to the rendered element, as in the pre-TS version. */
  isSecondary?: boolean;
} & React.HTMLAttributes<HTMLElement>;

class ProtectedButton extends Component<Props> {
  render() {
    const { tagName: CategoryName = 'button', children, onClick, ...restProps } = this.props;
    const elementProps = omit(
      restProps,
      'currentUser',
      'isBlocked',
      'dispatch',
      'viewMode',
      'isDemoMode',
      'openModal',
      'isAuthenticated',
      'isPrivate',
    );

    return (
      <CategoryName {...elementProps} onClick={onClick}>
        {children}
      </CategoryName>
    );
  }
}

export default ensureAuth(ProtectedButton);
